// src/lib/axios.js
import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE || "", // e.g. https://api.yourapp.com
  withCredentials: true,                         // <-- send/receive cookies
  headers: { "Content-Type": "application/json" }
});

// Optional: simple response error logging
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (process.env.NODE_ENV !== "production") {
      console.error("API error:", err?.response?.data || err.message);
    }
    return Promise.reject(err);
  }
);

export default api;
